import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

function getColor(color) {
  switch (color) {
    case "main":
      return "em-c-bulleted-list__item--main";
    case "accent":
      return "em-c-bulleted-list__item--accent";
    case "default":
    default:
      return "";
  }
}

const BulletedListItem = props => {
  const { className, color, children, ...other } = props;

  return (
    <li
      className={clsx("em-c-bulleted-list__item", getColor(color), className)}
      {...other}
    >
      {children}
    </li>
  );
};

BulletedListItem.propTypes = {
  /** Additional css classNames to append to the outer element */
  className: PropTypes.string,
  /** Theme color of the list items */
  color: PropTypes.oneOf(["default", "main", "accent"]),
  /** React component children */
  children: PropTypes.node
};

BulletedListItem.defaultProps = {
  className: "",
  color: "default",
  children: null
};

export default BulletedListItem;
